import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { AutoComplete } from '../../../../../../../components'
import { debounce } from '../../../../../../../utils'
import { isEqual } from 'lodash'

/**
 * Contact Job Institution: Form Component
 */
class Institution extends Component {

  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      institutions: []
    }
  }

  /**
   * ComponentDidMount
   */
  componentDidMount () {
    const { job, onValueChange } = this.props
    const institution = this.getInstitution(job)

    onValueChange(institution && institution.value)
  }

  /**
   * Component Did Update
   * @param prevProps
   */
  componentDidUpdate (prevProps) {
    const { suggestions } = this.props

    if (!isEqual(suggestions, prevProps.suggestions)) {
      this.setState({
        institutions: this.getInstitutionOptions(suggestions)
      })
    }
  }

  /**
   * ComponentWillUnmount
   */
  componentWillUnmount () {
    const { clearSuggestions } = this.props
    this.searchInstitutions.cancel() // reset debounce
    clearSuggestions()
  }

  /**
   * On field value change search institutions
   */
  searchInstitutions = debounce((value) => {
    const { searchInstitutions, clearSuggestions } = this.props;
    (value && value.length) ?
      searchInstitutions({ query: value }) : clearSuggestions()
  })

  /**
   * Normalize institution dropdown options
   * @param suggestions
   * @returns {{label: (string|*), value: *, selected: (*|boolean)}[]}
   */
  getInstitutionOptions = (suggestions) => {
    return (suggestions || []).map((suggestion) => {
      return {
        label: suggestion.institution_name,
        value: {
          _id: suggestion._id,
          q4_entity_id: suggestion.q4_entity_id,
          factset_entity_id: suggestion.factset_entity_id,
          institution_name: suggestion.institution_name,
          institution_type: suggestion.type,
          metro: suggestion.metro,
          address: suggestion.address
        }
      }
    })
  }

  /**
   * Prepopulate Institution on Edit
   * @param job
   * @returns {*}
   */
  getInstitution = (job) => {
    return ((job && job._id) ? {
      label: job.institution_name,
      value: {
        _id: job._id,
        q4_entity_id: job.q4_entity_id,
        factset_entity_id: job.factset_entity_id,
        institution_name: job.institution_name,
        institution_type: job.institution_type || job.type,
        metro: job.metro,
        address: job.address
      }
    } : null)
  }

  /**
   * Render
   * @return {XML}
   */
  render () {
    const { error, loading, job, onValueChange } = this.props
    const { institutions } = this.state

    return (
      <div className='field'>
        <label className='field_label'>Search Institution <span
          className='required'>(required)</span></label>
        <AutoComplete
          name='institution'
          error={error}
          loading={loading}
          showDropdownIndicator={false}
          defaultValue={this.getInstitution(job)}
          options={institutions}
          isLocal={false}
          onInputChange={this.searchInstitutions}
          onChange={(option) => onValueChange(option && option.value)}/>
      </div>
    )
  }
}

Institution.propTypes = {
  error: PropTypes.object,
  loading: PropTypes.bool,
  job: PropTypes.object,
  searchInstitutions: PropTypes.func.isRequired,
  suggestions: PropTypes.array,
  clearSuggestions: PropTypes.func.isRequired,
  onValueChange: PropTypes.func.isRequired
}

Institution.defaultProps = {
  loading: false,
  suggestions: []
}

export default Institution
